import { API_PORTAL_URL } from "@/lib/config";
import { axiosApiInstance } from "./axios";
import { getFromLocalStorage } from "@/utils/storage";

export const getLocalAccessToken = () => {
  return (
    getFromLocalStorage("nakman_token") ||
    (typeof window !== "undefined" ? localStorage.getItem("Token") : null)
  );
};

export const getLocalRefreshToken = () => {
  return typeof window !== "undefined"
    ? localStorage.getItem("RefreshToken")
    : null;
};

export const getRefreshToken = async () => {
  try {
    return await axiosApiInstance.post(
      `${API_PORTAL_URL}/UserLogin/CheckRefreshToken`,
      {
        refreshToken: getLocalRefreshToken(),
      },
    );
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.msg);
    console.error(error?.response?.data?.msg);
  }
};
